import { render, staticRenderFns } from "./cardShop.vue?vue&type=template&id=49e0e946&scoped=true&"
import script from "./cardShop.vue?vue&type=script&lang=js&"
export * from "./cardShop.vue?vue&type=script&lang=js&"
import style0 from "./cardShop.vue?vue&type=style&index=0&id=49e0e946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e0e946",
  null
  
)

export default component.exports